import { DateTime } from "luxon";
import { Dispatch, SetStateAction } from "react";
import { DateRange, DayPicker, getDefaultClassNames } from "react-day-picker";
import useRouterHandlerHook from "../_hooks/useRouterHandlerHook";
import CustomNav from "./CustomNav";
import SelectedRange from "./SelectedRange";

interface ICalenderBaseProps {
  month: Date | undefined;
  onMonthChange: Dispatch<SetStateAction<Date | undefined>>;
  selected: DateRange | undefined;
  setSelected: Dispatch<SetStateAction<DateRange | undefined>>;
  close: () => void;
}

const EmptyCaptionLabel = () => {
  return <></>;
};

const CalenderBase = ({
  selected,
  setSelected,
  month,
  onMonthChange,
  close,
}: ICalenderBaseProps) => {
  //Hook's
  const defaultClassNames = getDefaultClassNames();
  const { navigateTo, navigateBackTo } = useRouterHandlerHook();

  return (
    <div className="flex flex-col items-center justify-center gap-2 p-2 w-80 overflow-y-hidden">
      <SelectedRange range={selected} />
      <DayPicker
        month={month}
        onMonthChange={onMonthChange}
        mode="range"
        selected={selected}
        onSelect={(range) => setSelected(range)}
        components={{
          CaptionLabel: EmptyCaptionLabel,
          Nav: (props) => <CustomNav {...props} currentMonth={month as Date} />,
        }}
        classNames={{
          root: `${defaultClassNames}  h-60 w-full `,
          chevron: `fill-info`,
          caption_label: `text-center text-base font-medium text-black border`,
          month_grid: `w-full mb-2`,
          month: `px-2 w-full `,
          today: `!text-info`,
          selected: `bg-info/10`,
          range_start: `!bg-info rounded-l-md text-white`,
          range_end: `!bg-info rounded-r-md text-white`,
          outside: `!bg-white `,
          day: `font-semibold text-subHeading text-center p-2`,
          nav: `flex items-center justify-between px-2 w-full border`,
          weekdays: `text-darkGray text-sm font-light`,
          week: "text-sm text-subHeading",
        }}
      />
      <section className="flex justify-between w-full pt-5">
        <button
          type="button"
          className=" px-2 py-1  cursor-pointer rounded-md text-heading text-sm bg-white ring-1 ring-extraLightGray font-bold"
          onClick={() => {
            navigateBackTo({ searchKey: "created_between" });
            setSelected(undefined);
            close();
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={!selected?.from}
          className=" px-2 py-1 rounded-md text-white text-sm font-bold bg-primary cursor-pointer disabled:cursor-not-allowed "
          onClick={() => {
            navigateTo({
              search: {
                created_between:
                  String(
                    DateTime.fromJSDate(selected?.from as Date).toISODate()
                  ) +
                  "," +
                  String(DateTime.fromJSDate(selected?.to as Date).toISODate()),
              },
            });
            close();
          }}
        >
          Submit
        </button>
      </section>
    </div>
  );
};

export default CalenderBase;
